import { commonApi } from "@/api/common";

import type { MediaFile } from "./mediaStore";

export type MediaItemPayload = {
  mediaId: string;
  processedMediaId: string;
};

export const uploadMediaStoreFiles = async (
  files: MediaFile[]
): Promise<MediaItemPayload[]> => {
  const mediaItems = await Promise.all(
    files.map(async f => {
      if (f.file) {
        try {
          const response = await commonApi.mediaUpload(f.file);
          return { mediaId: response.id, processedMediaId: undefined };
        } catch (err) {
          console.error("Upload failed for file", f.file.name, err);
          return {
            mediaId: null,
            processedMediaId: undefined,
            error: true,
          };
        }
      } else if (f.id) {
        return {
          mediaId: undefined,
          processedMediaId: f.id,
        };
      }
      return { mediaId: undefined, processedMediaId: undefined };
    })
  );

  return mediaItems.map(item => ({
    mediaId: item.mediaId ?? "",
    processedMediaId: item.processedMediaId ?? "",
  }));
};
